import {Component, OnInit} from '@angular/core';
import {LoaderService} from '@app/shared/services';
import {OrderService} from '@app/shared/services/order.service';
import {ToastrService} from 'ngx-toastr';
import {RouterLink} from '@angular/router';
import {PageHeaderComponent} from '@app/components/page-header/page-header.component';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {PaginationComponent} from '@app/components/pagination/pagination.component';


@Component({
  selector: 'app-damage-list',
  templateUrl: './damage-list.component.html',
  imports: [
    CommonModule,
    FormsModule,
    RouterLink,
    PageHeaderComponent,
    PaginationComponent
  ],
  styleUrls: ['./damage-list.component.scss']
})
export class DamageListComponent implements OnInit {

  public user_rights: any;
  public user_data: any = {};
  public now = new Date();
  public damage_data: any = [];
  public damage: any =
    {
      search_damage: '',

    }
  start = 0;
  limit = 10;
  p = 50;
  public collection: any = '';
  page = 1;
  status: any;
  index: any;
  router: any;
  closeResult = '';

  total = 0;
  list: any;
  public institution = JSON.parse(localStorage.getItem('institution') || "{}");
  public logo_path = JSON.parse(localStorage.getItem('logo_path') || "{}");
  customer: any;
  date: any;
  toastr: ToastrService

  constructor(private loaderService: LoaderService, public orderService: OrderService, public toastrService: ToastrService) {
    this.toastr = toastrService
  }


  ngOnInit() {
    this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "{}");
    this.user_data = JSON.parse(localStorage.getItem('user') || "{}");
    this.getDamageList();
  }

  public keyDownFunction(event: any) {
    if (event.keyCode == 13) {
      this.getsearchlist();
    }
  }

  public getDamageList(page = 0) {
    const limit = 50;
    this.start = page * limit;
    this.limit = limit;
    const postData = {
      start: this.start,
      limit: this.limit,
      damage_id: '0'
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.orderService.listDamage(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.damage_data = result['data'];
        this.collection = result['total_count'];
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
        this.collection = 0;
        this.damage_data = []
      }
    });
  }

  getsearchlist() {
    const limit = 50;
    this.start = 0;
    this.limit = limit;
    const postData = {
      start: this.start,
      limit: this.limit,
      search_text: this.damage.search_damage,
      damage_id: '0'
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.orderService.listDamage(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.damage_data = result['data'];
        this.collection = result['total_count'];
        const i = this.damage_data.length;
        this.index = i + 5;
        this.status = result['status'];
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
        this.collection = 0;
        this.status = result['status'];
      }
    });
  }

  public clear_search() {
    if (this.damage.search_damage != '') {
      this.damage.search_damage = '';
      this.getDamageList();
    }
  }

  public deleteDamage(data: any) {
    const postData = {
      damage_purchase_id: data.DAMAGE_PURCHASE_ID,
      damage_purchase_details_id: data.DAMAGE_PURCHASE_DETAILS_ID,
      purchase_details_id: data.PURCHASE_DETAILS_ID,
      user_id: this.user_data.user_id
    };
    if (confirm("Are you sure to delete?")) {
      this.loaderService.display(true);
      this.orderService.deleteDamage(postData).subscribe((result: any) => {
        if (result['status'] == 'Success') {
          this.toastr.success(result["msg"])
          this.getDamageList();
          this.loaderService.display(false);
        } else {
          this.loaderService.display(false);
          this.toastr.error(result["msg"])
        }
      });
    }
  }

}
